import { MapLayer } from '@/types/config/settings.types';

import { CONFIG_URL, configApi } from './config.api';

export const mapLayerApi = configApi.injectEndpoints({
  endpoints: (builder) => ({
    getMapLayers: builder.query<MapLayer[], void>({
      query: () => ({
        url: `${CONFIG_URL}/map-layers`,
      }),
    }),
    createMapLayer: builder.mutation<MapLayer, MapLayer>({
      query: (mapLayer: MapLayer) => ({
        url: `${CONFIG_URL}/map-layers`,
        method: 'POST',
        body: mapLayer,
      }),
    }),
    updateMapLayer: builder.mutation<MapLayer, { id: number; mapLayer: MapLayer }>({
      query: ({ id, mapLayer }) => ({
        url: `${CONFIG_URL}/map-layers/${id}`,
        method: 'PUT',
        body: mapLayer,
      }),
    }),
    deleteMapLayer: builder.mutation<void, number>({
      query: (id) => ({
        url: `${CONFIG_URL}/map-layers/${id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const { useCreateMapLayerMutation } = mapLayerApi;
